import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const Cont = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.btnDetail':{
    alignSelf:'center',
    background:`${v.ezMainColor}`,
  },

  '.btnDetail:hover':{
    background:`${v.ezOrange}`,
  },

  '.btnDetail:focus':{
    background:`${v.ezMainColor}`,
  },
})